export enum CompletionDateType {
	Sched = 1,
	Current,
	Other
}
